import * as CookieConsent from "vanilla-cookieconsent";
import { createCookieConsent } from "../services/cookieConsent";

interface UserConsent {
  consentId: string;
  acceptType: string;
  acceptedCategories: string[];
  rejectedCategories: string[];
  timestamp: string;
  userAgent: string;
}

export async function logConsent(): Promise<void> {
  try {
    const cookie = CookieConsent.getCookie();
    const preferences = CookieConsent.getUserPreferences();

    const userConsent: UserConsent = {
      consentId: cookie.consentId,
      acceptType: preferences.acceptType,
      acceptedCategories: preferences.acceptedCategories,
      rejectedCategories: preferences.rejectedCategories,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    const result = await createCookieConsent(userConsent);

    if (result.status !== 200) {
      console.error("❌ Failed to log cookie consent:", result.error);
    }
  } catch (error) {
    console.error("Error logging consent:", error);
  }
}
